import React from 'react'
import { Sparkles, PhoneCall, ConciergeBell } from 'lucide-react'

const services = [
  { id: 1, name: 'Concierge', desc: 'Requests, reservations, and on-demand support.', icon: ConciergeBell },
  { id: 2, name: 'Wellness', desc: 'Spa, fitness, and recovery experiences tailored to you.', icon: Sparkles },
  { id: 3, name: 'Club line', desc: 'Call the front desk directly from the portal.', icon: PhoneCall },
]

export default function MemberServicesPage() {
  return (
    <div className="mp-panel">
      <div className="mp-panel__header">
        <div>
          <p className="mp-eyebrow">Services</p>
          <h4 className="mp-panel__title">Tailored for you</h4>
        </div>
        <button type="button" className="mp-secondary">Start a request</button>
      </div>
      <div className="mp-service__grid">
        {services.map((service) => {
          const Icon = service.icon
          return (
            <div key={service.id} className="mp-service-card">
              <div className="mp-service__icon">
                <Icon size={18} />
              </div>
              <h5>{service.name}</h5>
              <p>{service.desc}</p>
              <button type="button" className="mp-link">Open</button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
